import Dispatcher from "Dispatcher";
import PropTypes from "prop-types";
import { ReduceStore } from "flux/utils";
import typeCheckingStore from "data/util/typeCheckingStore";
import { hotLoadObject } from "data/storeUtils";
import HemoActions from "data/HemoActions";
import LoadObject from "data/LoadObject";
import dotProp from "dot-prop-immutable";
import DataManager from "data/DataManager";
import userStore from "data/userStore";
import TableAccess from "data/util/TableAccess";
import MapDialogActions from "data/MapDialogActions";

export const HEMO_MESSAGE_KEY = "hemo/1-0/message";

const getPagination = (state, query) =>
    state.pagination && state.pagination.hasOwnProperty(query)
        ? state.pagination[query]
        : {
            page: 1,
            pageCount: 0,
            pageSize: 25,
            totalResultCount: 0,
        };

const getQueryLO = (state, query) =>
    state.queries.hasOwnProperty(query)
        ? state.queries[query]
        : LoadObject.empty();

const idsToRecordsBuilder = state => {
    const access = new TableAccess(state);
    return ids => ids.map(id => access.getEntityProxy(HEMO_MESSAGE_KEY, id));
};

class HemoStore extends ReduceStore {

    constructor() {
        super(Dispatcher);
    }

    getInitialState() {
        return {
            tables: {},
            queries: {},
            pagination: {}
        };
    }

    reduce(state, action) {
        switch (action.type) {

            case HemoActions.SEARCH: {
                const lo = getQueryLO(state, action.query);
                return dotProp.set(
                    state,
                    ["queries", action.query],
                    lo.loading(DataManager.hemoSearch(
                        userStore.getActiveOrgKey(),
                        action.query,
                        action.interactive,
                    )),
                );
            }

            case HemoActions.SEARCH_RESULT: {
                // add response pagination info
                const newState = dotProp.set(
                    state,
                    ["pagination", action.query],
                    {
                        page: action.data.page,
                        pageCount: action.data.pageCount,
                        pageSize: action.data.pageSize,
                        query: action.data.query,
                        totalResultCount: action.data.totalResultCount,
                    }
                );
                const access = new TableAccess(newState);
                action.data.results.forEach(it =>
                    access.loadSuperRecordPacket(it));
                return dotProp.set(
                    access.getState(),
                    ["queries", action.query],
                    lo => lo.setValue(action.data.results.map(it => it.id)).done(),
                );
            }

            case HemoActions.SEARCH_ERROR: {
                return dotProp.set(
                    state,
                    ["queries", action.query],
                    lo => lo.setError(action.error).done(),
                );
            }

            case MapDialogActions.SELECT_PLUGIN: {
                return this.getInitialState(); // per Helen's decree
            }

            default:
                return state;
        }
    }
    getPagination(query) {
        return getPagination(this.getState(), query);
    }

    getColdLO(query) {
        return getQueryLO(this.getState(), query)
            .map(idsToRecordsBuilder(this.getState()));
    }

    getHotLO(query, interactive) {
        return hotLoadObject(
            () => getQueryLO(this.getState(), query),
            () => Dispatcher.dispatch({
                type: HemoActions.SEARCH,
                query,
                interactive,
            }),
            lo => interactive || lo.isEmpty()
        ).map(idsToRecordsBuilder(this.getState()));
    }

}

HemoStore.stateTypes = {
    tables: PropTypes.object.isRequired,
    queries: PropTypes.objectOf(PropTypes.instanceOf(LoadObject)).isRequired,
};

export default typeCheckingStore(new HemoStore());



// WEBPACK FOOTER //
// ./app/data/HemoStore.js